export default "__VITE_ASSET__be9cf310__"